import { type MutationError, trpc } from '@/shared/api';

interface UseDeleteLandingHeroImageOptions {
  readonly onSuccess?: () => void;
}

/** 행과 S3 객체를 함께 지운다. */
export const useDeleteLandingHeroImage = ({ onSuccess }: UseDeleteLandingHeroImageOptions = {}) => {
  const mutation = trpc.landing.deleteHeroImage.useMutation({ onSuccess });
  const error: MutationError | null = mutation.error;

  return {
    deleteImage: (id: string) => mutation.mutate({ id }),
    isPending: mutation.isPending,
    error,
    /** 지난 오류를 지운다 — 관리 화면의 다른 요청을 시작할 때 옛 오류가 남지 않게. */
    reset: mutation.reset,
  };
};
